<mat-form-field
  [appearance]="appearance"
  [subscriptSizing]="subscriptSizing"
  class="searchable-select"
  [class.mat-form-field-invalid]="showInvalidState()"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <span matPrefix class="searchable-select__prefix" *ngIf="selectedImageUrl() as imageUrl">
    <img [src]="imageUrl" alt="" class="searchable-select__thumb" />
  </span>
  <input
    #searchInput
    matInput
    type="text"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    [required]="showRequiredMarker()"
    autocomplete="off"
    role="combobox"
    (click)="onInputClick()"
    (blur)="onInputBlur()"
  />
  <mat-icon
    matSuffix
    class="searchable-select__chevron"
    aria-hidden="true"
    (mousedown)="$event.preventDefault()"
    (click)="onChevronClick()"
  >
    arrow_drop_down
  </mat-icon>
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option *ngIf="loading" disabled>
      <mat-spinner diameter="24"></mat-spinner>
    </mat-option>
    <ng-container *ngIf="!loading">
      <mat-option *ngIf="emptyLabel" [value]="null">
        {{ emptyLabel }}
      </mat-option>
      <mat-option
        *ngFor="let item of filtered; trackBy: trackByIndex"
        [value]="item"
      >
        <span class="searchable-select__option">
          <img
            *ngIf="imageWith?.(item) as imageUrl"
            [src]="imageUrl"
            alt=""
            class="searchable-select__thumb"
          />
          <span>{{ displayWith(item) }}</span>
        </span>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
